export const attributionConstants = {
  GET_ATTRIBUTION_DIMENSION_REQUEST: 'ATTRIBUTION/GET_ATTRIBUTION_DIMENSION_REQUEST',
  GET_ATTRIBUTION_DIMENSION_SUCCESS: 'ATTRIBUTION/GET_ATTRIBUTION_DIMENSION_SUCCESS',
  GET_ATTRIBUTION_DIMENSION_FAILED: 'ATTRIBUTION/GET_ATTRIBUTION_DIMENSION_FAILED',

  GET_ATTRIBUTION_MODEL_REQUEST: 'ATTRIBUTION/GET_ATTRIBUTION_MODEL_REQUEST',
  GET_ATTRIBUTION_MODEL_SUCCESS: 'ATTRIBUTION/GET_ATTRIBUTION_MODEL_SUCCESS',
  GET_ATTRIBUTION_MODEL_FAILED: 'ATTRIBUTION/GET_ATTRIBUTION_MODEL_FAILED',

  GET_ATTRIBUTION_CHANNEL_OVERLAP_TABLE_REQUEST: 'ATTRIBUTION/GET_ATTRIBUTION_CHANNEL_OVERLAP_TABLE_REQUEST',
  GET_ATTRIBUTION_CHANNEL_OVERLAP_TABLE_SUCCESS: 'ATTRIBUTION/GET_ATTRIBUTION_CHANNEL_OVERLAP_TABLE_SUCCESS',
  GET_ATTRIBUTION_CHANNEL_OVERLAP_TABLE_FAILED: 'ATTRIBUTION/GET_ATTRIBUTION_CHANNEL_OVERLAP_TABLE_FAILED',

  GET_ATTRIBUTION_CHANNEL_OVERLAP_CHART_REQUEST: 'ATTRIBUTION/GET_ATTRIBUTION_CHANNEL_OVERLAP_CHART_REQUEST',
  GET_ATTRIBUTION_CHANNEL_OVERLAP_CHART_SUCCESS: 'ATTRIBUTION/GET_ATTRIBUTION_CHANNEL_OVERLAP_CHART_SUCCESS',
  GET_ATTRIBUTION_CHANNEL_OVERLAP_CHART_FAILED: 'ATTRIBUTION/GET_ATTRIBUTION_CHANNEL_OVERLAP_CHART_FAILED',

  GET_AVAILABLE_TRAFFIC_SOURCES_REQUEST: 'ATTRIBUTION/GET_AVAILABLE_TRAFFIC_SOURCES_REQUEST',
  GET_AVAILABLE_TRAFFIC_SOURCES_SUCCESS: 'ATTRIBUTION/GET_AVAILABLE_TRAFFIC_SOURCES_SUCCESS',
  GET_AVAILABLE_TRAFFIC_SOURCES_FAILED: 'ATTRIBUTION/GET_AVAILABLE_TRAFFIC_SOURCES_FAILED',

  SET_SELECTED_DATERANGE_SUCCESS: 'ATTRIBUTION/SET_SELECTED_DATERANGE_SUCCESS',

  GET_ATTRIBUTION_UTMMAPPING_REQUEST: 'ATTRIBUTION/GET_ATTRIBUTION_UTMMAPPING_REQUEST',
  GET_ATTRIBUTION_UTMMAPPING_SUCCESS: 'ATTRIBUTION/GET_ATTRIBUTION_UTMMAPPING_SUCCESS',
  GET_ATTRIBUTION_UTMMAPPING_FAILED: 'ATTRIBUTION/GET_ATTRIBUTION_UTMMAPPING_FAILED'
};
